module.exports = __webpack_public_path__ + "static/media/mn3.bc2f3c65.jpeg";